import { ready } from 'brei-project-utils';
import { plugin } from './lib/plugin';

import { accordions } from './modules/accordions';
// Example of importing a custom module
import { drop } from './modules/drop';
import { primaryNav } from './modules/primary-nav';
import { search } from './modules/search';
import { Tooltip } from './modules/tooltip';

const main = {

	elem: {
		$textTooltip: $('.text-tooltip'),
		$tooltip: $('.tooltip')		
	},

	init() {
		// Init plugins
		plugin('Tooltip', Tooltip);

		accordions.init();
		drop.init();		
		primaryNav.init();		
		search.init();
		this.bindUIActions();

	},

	bindUIActions() {
		
	}

};

ready(function () {
	main.init();
});
